import './BoardView.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BoardHeader from './BoardHeader'
import Swimlanes from './Swimlanes'
import LoadingIndicator from '../../../components/LoadingIndicator'

class BoardView extends Component {
  UNSAFE_componentWillMount() {
    this.props.loadBoardData()
  }

  render() {
    if (!this.props.isLoaded) {
      return (
        <div className='board-view-loading-container'>
          <LoadingIndicator />
        </div>
      )
    }

    return (
      <div>
        <BoardHeader project={this.props.project} />
        <Swimlanes
          swimlanes={this.props.boardDef.swimlanes}
          project={this.props.project}
          tasks={this.props.tasks}
          onCardDrop={this.props.onCardDrop}
          onCardAdd={this.props.onCardAdd}
          isAddingTask={this.props.isAddingTask}
          isFilteredView={this.props.isFilteredView}
          taskAddCancel={this.props.taskAddCancel}
          taskAddSave={this.props.taskAddSave}
        />
      </div>
    )
  }
}

BoardView.propTypes = {
  isLoaded: PropTypes.bool,
  boardDef: PropTypes.object,
  tasks: PropTypes.object,
  project: PropTypes.object,
  loadBoardData: PropTypes.func,
  onCardDrop: PropTypes.func,
  onCardAdd: PropTypes.func,
  isFilteredView: PropTypes.bool,
  isAddingTask: PropTypes.bool,
  taskAddCancel: PropTypes.func.isRequired,
  taskAddSave: PropTypes.func.isRequired
}

export default BoardView



// WEBPACK FOOTER //
// ./src/routes/Board/components/BoardView.js